let instance = null;

export default class Singleton {  
  constructor() {
    if (!instance) {
      instance = this;
    }
    this.oAuthToken = null;
    this.company_id = null;
    this.uniqueUuid = null;
    this.Token = null;
    this.employeeId = null;
    this.roleId = null;
    this.responseId = null;
    return instance;
  }
}
